import { fetchAPI, handleResponse } from "./api"

const PROJECT_SESSION_KEY = "projects"

export async function loadProjects() {
  const projects = await fetchAPI<Project[]>(`/api/my/projects`)
    .then(handleResponse)
    .then((prjs) => prjs.filter((prj) => prj.active))

  sessionStorage.setItem(PROJECT_SESSION_KEY, JSON.stringify(projects))

  return projects
}

export function getProjects() {
  const projects = sessionStorage.getItem(PROJECT_SESSION_KEY)

  if (projects == null) throw new Error("Projects not loaded")

  return JSON.parse(projects) as Project[]
}

export function getOrganisations() {
  const projects = sessionStorage.getItem(PROJECT_SESSION_KEY)

  if (projects == null) throw new Error("Projects not loaded")

  const organisations = (JSON.parse(projects) as Project[]).map((prj) => prj.organisation)

  return [...new Set(organisations)]
}

export function getProjectsByOrganisation(organisation: string): string[] {
  return getProjects()
    .filter((prj) => prj.organisation === organisation)
    .map((prj) => prj.name)
}

interface Project {
  organisation: string
  name: string
  active: boolean
}
